import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { E2ELoadingPage } from "./LoadingPage";

export function E2ERoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/loading`}>
        <E2ELoadingPage />
      </Route>
    </Switch>
  );
}
